"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _importGoods = _interopRequireDefault(require("./importGoods"));
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'StudioList',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        });
      }
    }
  },
  components: {
    importGoods: _importGoods.default
  },
  data: function data() {
    return {
      loadingBtn: false,
      loading: false,
      Loading: false,
      dialogVisible: false,
      //编辑小助手弹窗
      importVisible: false,
      //导入商品弹窗
      listLoading: true,
      studioShowStatusList: [{
        label: '显示',
        value: 1
      }, {
        label: '关闭',
        value: 0
      }],
      studioStatusList: [{
        label: '直播中',
        value: '101'
      }, {
        label: '已结束',
        value: '103'
      }, {
        label: '未开始',
        value: '102'
      }, {
        label: '禁播',
        value: '104'
      }, {
        label: '暂停',
        value: '105'
      }, {
        label: '异常',
        value: '106'
      }, {
        label: '已过期',
        value: '107'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        reviewStatus: null,
        liveStatus: null,
        keywords: '',
        storeShow: ''
      },
      reviewStatus: null,
      keywords: '',
      roomId: '',
      liveRoomStatus: '',
      roomInfo: {},
      search: {
        //小助手
        limit: this.$constants.page.limit[0],
        page: 1,
        keywords: ''
      },
      assistantList: [],
      //小助手列表
      users: [],
      //小助手id集合
      goodList: [],
      //导入商品id集合
      sharecode: '',
      //分享二维码
      sharecodeVisible: false,
      //直播间分享码显示隐藏
      assistant: '',
      //直播间小助手 id
      code: 'https://res.wx.qq.com/op_res/9rSix1dhHfK4rR049JL0PHJ7TpOvkuZ3mE0z7Ou_Etvjf-w1J_jVX0rZqeStLfwh' //主播码
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:mp:live:room:list'])) this.getList();
    this.getAssistantList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //获取直播间二维码
    onSharecode: function onSharecode(id) {
      var _this = this;
      this.sharecodeVisible = true;
      this.loading = true;
      (0, _marketing.liveRoomGetsharecodeApi)(id).then(function (res) {
        _this.sharecode = res;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    //获取导入商品id集合
    getGoodList: function getGoodList(goodList) {
      this.goodList = goodList;
    },
    //导入商品提交
    onSubmit: function onSubmit() {
      var _this2 = this;
      if (!this.goodList.length) return this.$message.warning('请至少选择一个商品提交');
      (0, _marketing.liveRoomAddgoodsApi)({
        id: this.roomId,
        ids: this.goodList
      }).then(function (res) {
        _this2.importVisible = false;
        _this2.$message.success('导入商品成功');
        _this2.getList();
      });
    },
    // 关闭导入商品
    handleClose: function handleClose(n) {
      this[n] = false;
    },
    //添加小助手
    handleAssistant: function handleAssistant() {
      var _this3 = this;
      (0, _marketing.liveRoomMangerassApi)({
        id: this.roomId,
        assid: this.users
      }).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.dialogVisible = false;
      }).catch(function (res) {
        _this3.dialogVisible = false;
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getAssistantList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this4 = this;
      this.loading = true;
      this.search.keywords = query;
      this.search.page = 1;
      this.assistantList = [];
      setTimeout(function () {
        _this4.loading = false;
        _this4.getMerList(); // 请求接口
      }, 200);
    },
    // 小助手列表
    getAssistantList: function getAssistantList() {
      var _this5 = this;
      (0, _marketing.liveAssistantListApi)(this.search).then(function (res) {
        _this5.totalPage = res.totalPage;
        _this5.total = res.total;
        _this5.assistantList = _this5.assistantList.concat(res.list);
      });
    },
    //直播间商品列表
    roomGoodslist: function roomGoodslist() {
      var _this6 = this;
      (0, _marketing.liveRoomGoodslistApi)(this.roomId).then(function () {
        _this6.$message.success('删除成功');
        _this6.tableData.data.splice(idx, 1);
      });
    },
    // 导入
    handleImport: function handleImport(row) {
      this.roomId = row.id;
      this.importVisible = true;
    },
    // 编辑助手
    onEditAssistant: function onEditAssistant(row) {
      this.assistant = row.assistant;
      this.users = [];
      this.roomId = row.id;
      this.getModifyass();
      this.dialogVisible = true;
      // this.$modalForm(studioEditAssistant(id)).then(() => this.getList(''));
    },
    //查询直播间小助手
    getModifyass: function getModifyass() {
      var _this7 = this;
      (0, _marketing.liveRoomGetassApi)(this.roomId).then(function (res) {
        res.map(function (item) {
          _this7.users.push(item.id);
        });
      });
    },
    // 删除
    handleDelete: function handleDelete(item, idx) {
      var _this8 = this;
      this.$modalSure('该直播间正在进行直播，删除后不可恢复，您确认删除吗？').then(function () {
        (0, _marketing.liveRoomDeleteApi)(item.id).then(function () {
          _this8.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this8.tableData.data.length, _this8.tableForm);
          _this8.getList();
        });
      });
    },
    // 推送消息
    onPushMessage: function onPushMessage(id) {
      var _this9 = this;
      this.$confirm('给长期订阅用户推送消息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _marketing.studioPushMessageApi)(id).then(function (_ref) {
          var message = _ref.message;
          _this9.$message.success(message);
        }).catch(function (_ref2) {
          var message = _ref2.message;
          _this9.$message.error(message);
        });
      }).catch(function (action) {
        _this9.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 编辑
    onEdit: function onEdit(id) {
      //this.$modalForm(studioEdit(id)).then(() => this.getList(''));
    },
    handleReset: function handleReset() {
      this.tableForm.limit = this.$constants.page.limit[0];
      this.tableForm.liveStatus = null;
      this.tableForm.keywords = '';
      this.tableForm.storeShow = '';
      this.keywords = '';
      this.getList(1);
    },
    // 列表
    getList: function getList(num) {
      var _this0 = this;
      this.listLoading = true;
      this.tableForm.page = num ? num : this.tableForm.page;
      this.tableForm.keywords = encodeURIComponent(this.keywords);
      this.tableForm.reviewStatus = this.reviewStatus ? Number(this.reviewStatus) : null;
      this.tableForm.liveStatus = this.tableForm.liveStatus ? this.tableForm.liveStatus : null;
      (0, _marketing.liveRoomListApi)(this.tableForm).then(function (res) {
        _this0.tableData.data = res.list;
        _this0.tableData.total = res.total;
        _this0.listLoading = false;
      }).catch(function (res) {
        _this0.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableForm.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableForm.limit = val;
      this.getList('');
    },
    //开启回放
    onchangeCloseReplay: function onchangeCloseReplay(row) {
      var _this1 = this;
      (0, _marketing.liveRoomUpdatereplayApi)(row.id, row.liveReplay).then(function () {
        _this1.$message.success('操作成功');
        _this1.getList('');
      });
    },
    // 开启收录
    onchangeIsFeeds: function onchangeIsFeeds(row) {
      var _this10 = this;
      (0, _marketing.liveRoomIsFeedsPublicApi)(row.id, row.isFeedsPublic).then(function () {
        _this10.$message.success('操作成功');
        _this10.getList('');
      });
    },
    // 禁言
    onchangeIsCommen: function onchangeIsCommen(row) {
      var _this11 = this;
      (0, _marketing.liveRoomUpdatecommentApi)(row.id, row.closeComment).then(function () {
        _this11.$message.success('操作成功');
        _this11.getList('');
      });
    },
    // 客服
    onchangeIsKf: function onchangeIsKf(row) {
      var _this12 = this;
      (0, _marketing.liveRoomUpdateclosekfApi)(row.id, row.closeKf).then(function () {
        _this12.$message.success('操作成功');
        _this12.getList('');
      });
    }
  }
};